import { Component, OnInit, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Urls } from '../../../../utils/catalogue/urls';
import { ApiService } from '../../../../shared/catalogue/services/api.service';
import { CommonDataService } from '../../../../shared/catalogue/services/common-data.service';
import { DATA_PER_PAGE, File_deleted, CANCEL, Please_upload_File, File_uploaded } from './../../../../app.constant';

@Component({
  selector: 'app-forms-collaterals',
  templateUrl: './forms-collaterals.component.html',
  styleUrls: ['./forms-collaterals.component.scss'],
})
export class FormsCollateralsComponent implements OnInit {
  @Input() type;
  @Input() id;

  @Input() data: any[];

  files: File[] = [];
  dataFile = 'Upload File';
  userData: any = {};

  sectionList = [];
  subSectionList = [];

  pageSize: number = DATA_PER_PAGE;

  constructor(
    public apiService: ApiService,
    private toastr: ToastrService,
    public commonDataService: CommonDataService
  ) {}

  ngOnInit() {
    this.getSection();
  }

  getSection = () => {
    this.apiService
      .postData(Urls.getSectionsByType, { typeId: this.id })
      .subscribe((response: any) => {
        this.sectionList = response.data.subTypes;
      });
    this.getDocs();
  };

  getSubSectionsBySection = () => {
    const index = this.sectionList.findIndex(
      (x) => x.sections === this.userData.section
    );
    const id = this.sectionList[index].id;
    this.apiService
      .postData(Urls.getSubSectionsByType, { sectionId: id })
      .subscribe((response: any) => {
        this.subSectionList = response.data.list;
      });
  };

  getDocs = () => {
    let obj;
    this.apiService
      .getData(Urls.getSubSectiondocs)
      .subscribe((response: any) => {
        obj = response.data.list;
        this.data = obj.filter((obj) => {
          const type = obj.type.trim(); 
          return type === 'Forms and Marketing Colletarals' ;
        });
      });

  };

  viewFile = (path) => {
    window.open(path, '_blank');
  };

  deleteData = (data) => {
    const obj = {
      type: data.type,
      id: data.id,
    };
    this.commonDataService
      .confirm('Are you sure want to delete?', 'md')
      .then((confirmed) => {
        if (confirmed) {
          this.apiService
            .postData(Urls.deleteSubSectionDocuments, obj)
            .subscribe((response: any) => {
              this.toastr.success(File_deleted);
              this.getDocs();
            });
        }
      })
      .catch(() => {
        this.toastr.error(CANCEL);
      });
  };

 
}
